// @mui
import { Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
//
import { MotivationIllustration } from '../../assets';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  backgroundColor: theme.palette.primary.lighter,
  [theme.breakpoints.up('md')]: {
    height: '100%',
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));

// ----------------------------------------------------------------------

export default function Welcome() {
  return (
    <RootStyle>
      <CardContent
        sx={{
          color: 'grey.800',
          p: { md: 5 },
        }}
      >
        <Typography gutterBottom variant="h4">
          CÁC ỨNG DỤNG,
          <br /> ÔN THI GPLX Ô TÔ, XE MÁY
        </Typography>

        <Typography variant="body2" sx={{ pb: { xs: 1, xl: 2 }, mx: 'auto', mt: 2 }}>
          Với giao diện thân thiện và câu hỏi được tùy chỉnh theo các chủ đề khác nhau, ứng dụng này cho phép người dùng
          ôn tập kiến thức và cải thiện sự hiểu biết về luật lệ giao thông, biển báo, và hành vi an toàn khi tham gia
          giao thông.
        </Typography>
      </CardContent>

      <MotivationIllustration
        sx={{
          p: 1,
          width: 200,
          margin: { xs: 'auto', md: 'inherit' },
        }}
      />
    </RootStyle>
  );
}
